module.exports = __webpack_public_path__ + "static/media/email_alt.7d34c679.svg";